export function capitalizeString(str: string, capitalizeOnSeparators?: boolean, separators?: string[]) {
    if (!str || str.length === 0) return '';

    if (capitalizeOnSeparators) {
        for (const separator of (separators || ['-', '_', ' ', '/'])) {
            var splitted = str.split(separator);
            str = splitted.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(separator);
        }
    }

    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function titleCase(str?: string | null): string {
    if (!str) return '';
    return capitalizeString(str.toLocaleLowerCase(), true);
}

/**
 * Removes all umlauts and accents from a string by normalizing it
 * @param str - String to normalize
 * @returns String with umlauts and accents removed
 */
export function removeAccents(str: string): string {
    if (!str) return '';
    
    return str
        .normalize('NFD') // Decompose accented characters into base + combining marks
        .replace(/[\u0300-\u036f]/g, '') // Remove all combining diacritical marks
        .normalize('NFC'); // Recompose remaining characters
}

export function formatDate(date?: Date, lang?: string): string {
    if (!date) return '';

    if (lang === 'en') {
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    }

    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}

async function checkImageExists(imageUrl: string): Promise<boolean> {
    if (!imageUrl) return false;

    try {
        const response = await fetch(imageUrl, {
            method: 'HEAD',
            cache: 'force-cache',
        });

        return response.ok;
    } catch (error) {
        return false;
    }
}

function generateTransformedUrl(imageUrl: string, suffix: string): string {
    if (imageUrl && imageUrl.includes('http') && imageUrl.includes('library') && imageUrl.includes('.')) {
        let transformedUrl = imageUrl.replace('library', 'custom');

        const extensionIndex = transformedUrl.lastIndexOf('.');
        const extension = transformedUrl.substring(extensionIndex);
        transformedUrl = transformedUrl.substring(0, extensionIndex) + suffix + extension;

        return transformedUrl;
    }

    return imageUrl;
}

export async function getTransformedImage(imageUrl: string, suffixes: string[]): Promise<string> {
    if (!imageUrl || !suffixes.length) return imageUrl;

    if (!(imageUrl.includes('http') && imageUrl.includes('library') && imageUrl.includes('.'))) {
        return imageUrl;
    }

    for (const suffix of suffixes) {
        const transformedUrl = generateTransformedUrl(imageUrl, suffix);
        const imageExists = await checkImageExists(transformedUrl);

        if (imageExists) {
            return transformedUrl;
        }
    }

    return imageUrl;
}
/**
 * Fecha larga de evento con día de semana, capitalizada — el formato de la cabecera de la
 * ficha pública ("Sábado, 25 de julio de 2026"). Compartido por EventCard (ficha) y
 * EventPublicHeader (sub-páginas del árbol /event/*) para que nunca diverjan.
 * Mapeo de culture heredado del legacy: eu → GB.
 */
export function formatEventDateLong(iso: string, lang: string): string {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '';
    const culture = lang === 'eu' ? 'GB' : lang.toUpperCase();
    const formatted = date.toLocaleDateString(`${lang}-${culture}`, {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
    });
    return capitalizeString(formatted);
}
